export default __webpack_public_path__ + "assets/images/84c6e1d2c50844b66d587dc1ba9e9058.svg";